const INITIAL_STATE = { 
    registro: {}, 
    modoTela: 'lista', 
    lista: [], 
    listaVeiculoTipo: []
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
		case 'VEICULO_TIPO_CONSUMO_MODO_TELA':
            return { ...state,
				modoTela: action.payload.modo,
				registro: action.payload.registro
			};

        case 'VEICULO_TIPO_CONSUMO_LISTADO':
            return { ...state, lista: action.payload.data };

        case 'VEICULO_TIPO_CONSUMO_VEICULO_TIPO_SELECT_LISTADO':
			return {
				...state,
				listaVeiculoTipo: action.payload.data
			};

        default:
            return state;
    }
}
